import React from 'react';
import { CheckSquare } from 'lucide-react';
export function PainChecklist() {
  const items = ['¿Tu panza está plana a la mañana y a la noche parece un globo?', '¿Comés "sano" pero cada vez que comés verdura o legumbres te inflamás más?', '¿Tu médico te dijo "es estrés" o "es colon irritable" y ningún tratamiento funcionó?', '¿Tenés gases, fatiga crónica y una niebla mental que no pasa ni durmiendo bien?', '¿Llevás meses o años buscando respuestas y cada solución que probaste fue temporal?'];
  return <section className="bg-forest-50 py-16 px-4" data-id="element-170">
      <div className="max-w-3xl mx-auto" data-id="element-171">
        <h3 className="text-2xl font-bold text-forest-900 mb-8 text-center" data-id="element-172">
          Respondé honestamente:
        </h3>

        <div className="space-y-6 bg-white p-8 rounded-2xl border border-forest-800/10 shadow-sm" data-id="element-173">
          {items.map((item, index) => <div key={index} className="flex items-start space-x-4" data-id="element-174">
              <CheckSquare className="w-6 h-6 text-pain flex-shrink-0 mt-1" data-id="element-175" />
              <p className="text-lg md:text-xl text-forest-800 font-medium" data-id="element-176">
                {item}
              </p>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-177">
          <p className="text-xl md:text-2xl font-bold text-forest-900" data-id="element-178">
            Si marcaste 2 o más... no es tu culpa.
          </p>
          <p className="text-lg md:text-xl text-forest-800 mt-2" data-id="element-179">
            Es que nadie te explicó qué está pasando realmente adentro de tu
            intestino.
          </p>
        </div>
      </div>
    </section>;
}